<app-navbar />

<div class="min-h-screen bg-gray-100">
  <!-- Toggle de Vista (Solo móvil) -->
  <div class="lg:hidden sticky top-0 z-40 bg-white shadow-sm border-b p-4">
    <button
      (click)="togglePreview()"
      class="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center justify-center gap-2">
      @if (showPreview()) {
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        <span>Ver Formulario</span>
      } @else {
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <span>Ver Vista Previa</span>
      }
    </button>
  </div>

  <!-- Layout Principal: Formulario + Preview -->
  <div class="lg:grid lg:grid-cols-2 lg:gap-0 lg:h-screen">

    <!-- COLUMNA IZQUIERDA: Formulario -->
    <div
      class="lg:overflow-y-auto lg:h-screen bg-white"
      [class.hidden]="showPreview()"
      [class.lg:block]="true">

      <div class="max-w-4xl mx-auto p-6">
        <div class="mb-6">
          <h2 class="text-3xl font-bold text-gray-800 mb-2">
            Constructor de Landing Pages
          </h2>
          <p class="text-gray-600">
            Edita el contenido y ve los cambios en tiempo real →
          </p>
        </div>

        <!--
          🔥 AQUÍ PEGA TODO TU FORMULARIO EXISTENTE
          Desde <form [formGroup]="landingForm"> hasta </form>
          Sin cambiar NADA del código que ya tienes
        -->

        <form [formGroup]="landingForm" (ngSubmit)="onSubmit()" class="space-y-6">

        <!-- SECCIÓN: Información Básica -->
        <div class="p-4 bg-blue-50 rounded-lg">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">📋 Información Básica</h3>

            <!-- Título -->
            <div class="mb-4">
                <label for="title" class="block text-sm font-medium text-gray-700 mb-2">
                    Título de la Página *
                </label>
                <input type="text" id="title" formControlName="title" (blur)="generateSlugFromTitle()"
                    placeholder="Ej: Cabaña El Mirador"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    [class.border-red-500]="landingForm.get('title')?.invalid && landingForm.get('title')?.touched" />
                @if (landingForm.get('title')?.invalid && landingForm.get('title')?.touched) {
                <p class="text-red-500 text-sm mt-1">
                    El título es obligatorio (mínimo 3 caracteres)
                </p>
                }
            </div>

            <!-- Slug con Preview -->
            @if (slugPreview()) {
            <div
                class="mt-3 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm animate-fade-in">
                <div class="flex items-start gap-3">
                    <svg class="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                    <div class="flex-1">
                        <p class="text-xs font-semibold text-blue-700 uppercase tracking-wide mb-1">
                            Vista Previa de la URL
                        </p>
                        <code
                            class="text-sm text-blue-900 font-mono bg-white px-3 py-1.5 rounded border border-blue-200 break-all block">
                            {{ slugPreview() }}
                        </code>
                    </div>
                </div>
            </div>
            }
        </div>
        <!-- ⬆️ CIERRE DE INFORMACIÓN BÁSICA -->

        <!-- SECCIÓN: Contenido Hero -->
        <div class="p-4 bg-purple-50 rounded-lg">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">🎨 Sección Hero (Portada)</h3>

            <!-- Hero Title -->
            <div class="mb-4">
                <label for="hero_title" class="block text-sm font-medium text-gray-700 mb-2">
                    Título Principal del Hero *
                </label>
                <input type="text" id="hero_title" formControlName="hero_title"
                    placeholder="Ej: Bienvenidos a Cabaña El Mirador"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
                    [class.border-red-500]="landingForm.get('hero_title')?.invalid && landingForm.get('hero_title')?.touched" />
                @if (landingForm.get('hero_title')?.invalid && landingForm.get('hero_title')?.touched) {
                <p class="text-red-500 text-sm mt-1">El título del hero es obligatorio</p>
                }
            </div>

            <!-- Hero Subtitle -->
            <div>
                <label for="hero_subtitle" class="block text-sm font-medium text-gray-700 mb-2">
                    Subtítulo del Hero
                </label>
                <input type="text" id="hero_subtitle" formControlName="hero_subtitle"
                    placeholder="Ej: Tu refugio en las montañas"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition" />
                <p class="text-sm text-gray-500 mt-1">Opcional: Texto secundario debajo del título principal</p>
            </div>
        </div>

        <!-- SECCIÓN: Contenido Principal -->
        <div class="p-4 bg-green-50 rounded-lg">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">📝 Descripción Principal</h3>

            <div>
                <label for="main_description" class="block text-sm font-medium text-gray-700 mb-2">
                    Descripción del Alojamiento *
                </label>
                <textarea id="main_description" formControlName="main_description" rows="4"
                    placeholder="Ej: Disfruta de la naturaleza en nuestro acogedor espacio. Ideal para escapadas de fin de semana..."
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition resize-none"
                    [class.border-red-500]="landingForm.get('main_description')?.invalid && landingForm.get('main_description')?.touched"></textarea>
                @if (landingForm.get('main_description')?.invalid && landingForm.get('main_description')?.touched) {
                <p class="text-red-500 text-sm mt-1">La descripción es obligatoria</p>
                }
            </div>
        </div>

        <!-- SECCIÓN: SEO -->
        <div class="p-4 bg-yellow-50 rounded-lg">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">🔍 Optimización SEO</h3>

            <!-- Meta Title -->
            <div class="mb-4">
                <label for="meta_title" class="block text-sm font-medium text-gray-700 mb-2">
                    Meta Title (SEO)
                </label>
                <input type="text" id="meta_title" formControlName="meta_title"
                    placeholder="Deja vacío para usar el título principal"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition" />
                <p class="text-sm text-gray-500 mt-1">
                    Opcional: Título optimizado para buscadores (si es diferente al título principal)
                </p>
            </div>

            <!-- Meta Description -->
            <div class="mb-4">
                <label for="meta_description" class="block text-sm font-medium text-gray-700 mb-2">
                    Meta Description (SEO)
                </label>
                <textarea id="meta_description" formControlName="meta_description" rows="3"
                    placeholder="Hermosa cabaña con vista a las montañas. Ideal para escapadas de fin de semana."
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition resize-none"
                    [class.border-red-500]="landingForm.get('meta_description')?.invalid && landingForm.get('meta_description')?.touched"></textarea>
                <p class="text-sm text-gray-500 mt-1">
                    {{ landingForm.get('meta_description')?.value?.length || 0 }} / 160 caracteres
                </p>
            </div>

            <!-- OG Image -->
            <!-- <div class="mb-4">
                <label for="og_image" class="block text-sm font-medium text-gray-700 mb-2">
                    Imagen Open Graph (URL)
                </label>
                <input type="url" id="og_image" formControlName="og_image"
                    placeholder="https://ejemplo.com/og-image.jpg"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition" />
                <p class="text-sm text-gray-500 mt-1">
                    URL de la imagen para compartir en redes sociales
                </p>
            </div> -->

            <!-- Keywords -->
            <div>
                <label for="keywords" class="block text-sm font-medium text-gray-700 mb-2">
                    Palabras Clave (Keywords)
                </label>
                <input type="text" id="keywords" formControlName="keywords"
                    placeholder="cabaña, montaña, turismo rural, alojamiento"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition" />
                <p class="text-sm text-gray-500 mt-1">
                    Separa las palabras clave con comas
                </p>
            </div>
        </div>

        <!-- SECCIÓN: Imágenes -->
        <div class="p-4 bg-indigo-50 rounded-lg">
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-lg font-semibold text-gray-800">🖼️ Galería de Imágenes</h3>
                <button type="button" (click)="addImage()"
                    class="px-4 py-2 bg-blue-800 text-white rounded-lg hover:bg-blue-500 transition flex items-center gap-2">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Agregar Imagen
                </button>
            </div>

            @if (images.length === 0) {
            <div class="p-6 border-2 border-dashed border-indigo-300 rounded-lg text-center bg-white">
                <svg class="w-12 h-12 mx-auto text-indigo-400 mb-2" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <p class="text-gray-500">No hay imágenes agregadas. Haz clic en "Agregar Imagen" para empezar.</p>
            </div>
            }

            <!-- Iteración sobre el FormArray -->
            <div formArrayName="images" class="space-y-4">
                @for (imageControl of images.controls; track $index) {
                <div [formGroupName]="$index" class="p-4 border rounded-lg bg-white shadow-sm">
                    <div class="flex justify-between items-start mb-3">
                        <h4 class="font-medium text-gray-700">Imagen {{ $index + 1 }}</h4>
                        <button type="button" (click)="removeImage($index)"
                            class="text-red-600 hover:text-red-800 transition" title="Eliminar imagen">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <!-- Input de archivo -->
                    <div class="mb-3">
                        <label [for]="'file-' + $index" class="block text-sm font-medium text-gray-600 mb-2">
                            Seleccionar archivo * (JPG, PNG, WebP - Max 5MB)
                        </label>
                        <input type="file" [id]="'file-' + $index" accept="image/jpeg,image/png,image/webp,image/jpg"
                            (change)="onFileSelected($event, $index)"
                            class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-indigo-100 cursor-pointer" />
                    </div>

                    <!-- Preview de la imagen -->
                    @if (imageControl.get('preview')?.value) {
                    <div class="mb-3">
                        <img [src]="imageControl.get('preview')?.value" alt="Preview"
                            class="max-h-48 rounded-lg shadow-sm object-cover" />
                    </div>
                    }

                    <!-- Alt Text -->
                    <div>
                        <label [for]="'alt-' + $index" class="block text-sm font-medium text-gray-600 mb-2">
                            Texto Alternativo (Alt Text) *
                            <span class="text-xs text-gray-500">(para SEO y accesibilidad)</span>
                        </label>
                        <input type="text" [id]="'alt-' + $index" formControlName="alt_text"
                            placeholder="Vista frontal de la cabaña"
                            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                            [class.border-red-500]="imageControl.get('alt_text')?.invalid && imageControl.get('alt_text')?.touched" />
                        @if (imageControl.get('alt_text')?.invalid && imageControl.get('alt_text')?.touched) {
                        <p class="text-red-500 text-sm mt-1">
                            El texto alternativo es obligatorio para SEO
                        </p>
                        }
                    </div>
                </div>
                }
            </div>

            <!-- Barra de progreso de subida -->
            @if (uploadProgress() > 0 && uploadProgress() < 100) { <div
                class="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div class="flex justify-between items-center mb-2">
                    <span class="text-sm font-medium text-blue-700">
                        📤 Subiendo imágenes... {{ uploadProgress().toFixed(0) }}%
                    </span>
                    <span class="text-xs text-blue-600 font-semibold">
                        {{ uploadingCount() }} / {{ images.length }} completadas
                    </span>
                </div>
                <div class="w-full bg-blue-200 rounded-full h-3 overflow-hidden">
                    <div class="bg-gradient-to-r from-blue-500 to-indigo-600 h-3 rounded-full transition-all duration-300 ease-out shadow-sm"
                        [style.width.%]="uploadProgress()">
                    </div>
                </div>
                <p class="text-xs text-blue-600 mt-2 text-center">
                    Por favor espera mientras se suben las imágenes...
                </p>
        </div>
        }

        @if (uploadProgress() === 100) {
        <div class="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2">
            <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <span class="text-sm text-green-700 font-medium">
                ✅ Todas las imágenes subidas exitosamente
            </span>
        </div>
        }
</div>

<!-- SECCIÓN: HTML Personalizado (Opcional) -->
<div class="p-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
    <h3 class="text-lg font-semibold text-gray-800 mb-4">⚙️ HTML/CSS Personalizado (Avanzado)</h3>

    <div>
        <label for="custom_html" class="block text-sm font-medium text-gray-700 mb-2">
            Puedes utilizar código HTML y CSS inline
        </label>
        <textarea id="custom_html" formControlName="custom_html" rows="6"
            placeholder="<p style='color: red;'>...</p>"
            class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-transparent transition resize-none font-mono text-sm bg-gray-900 text-green-400"></textarea>
        <p class="text-sm text-gray-500 mt-1">
            ⚠️ Solo para usuarios avanzados: Inyecta HTML/CSS personalizado
        </p>
    </div>
</div>

<!-- Mensajes de Error/Éxito -->
@if (submitError()) {
<div class="p-4 bg-red-50 border-l-4 border-red-500 rounded-lg flex items-start gap-3">
    <svg class="w-6 h-6 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="text-red-700">{{ submitError() }}</p>
</div>
}

@if (submitSuccess()) {
<div class="p-4 bg-green-50 border-l-4 border-green-500 rounded-lg">
    <div class="flex items-start gap-3">
        <svg class="w-6 h-6 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div>
            <p class="text-green-700 font-medium">{{ submitSuccess() }}</p>
            @if (previewUrl()) {
            <a [href]="previewUrl()" target="_blank"
                class="text-green-600 hover:text-green-800 text-sm underline mt-1 inline-block">
                Ver página →
            </a>
            }
        </div>
    </div>
</div>
}

<!-- Botones de Acción -->
<div class="flex gap-4 pt-4 border-t">
    <button type="submit" [disabled]="landingForm.invalid || isSubmitting() || images.length === 0"
        class="flex-1 px-6 py-3 bg-blue-800 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition flex items-center justify-center gap-2">
        @if (!isSubmitting()) {
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        <span>Crear Landing Page</span>
        } @else {
        <svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
        </svg>
        <span>Creando...</span>
        }
    </button>

    <button type="button" (click)="resetForm()" [disabled]="isSubmitting()"
        class="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
        Limpiar
    </button>
</div>

</form>

      </div>
    </div>

    <!-- COLUMNA DERECHA: Vista Previa -->
    <div
      class="lg:overflow-y-auto lg:h-screen bg-gray-50 border-l border-gray-200 sticky top-0"
      [class.hidden]="!showPreview()"
      [class.lg:block]="true">

      <div class="sticky top-0 z-30 bg-white border-b px-6 py-4 shadow-sm">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            Vista Previa en Vivo
          </h3>
          <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
            Auto-actualizado
          </span>
        </div>
      </div>

      @if (previewData()) {
        <landing-preview [data]="previewData()!" />
      } @else {
        <div class="flex items-center justify-center h-full p-12">
          <div class="text-center">
            <svg class="w-20 h-20 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p class="text-gray-500 text-lg">Completa el formulario para ver la vista previa</p>
          </div>
        </div>
      }

    </div>
  </div>
</div>

<app-footer />
